import { useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { IPromotionCouponDetail } from "interfaces";
import { endpointService } from "components/shared/services/endpointService";
import { EditPromotionCouponForm } from "components/shared/promotion/forms";

export const EditWPSPromotionCoupon: React.FC = () => {
  const parse = useParse();
  const { params } = parse();

  const { data: couponDetail } = useOne<IPromotionCouponDetail>({
    resource: endpointService.getPromotionEndPoint("getCouponDetail", {
      couponId: params?.id,
    }),
    id: "",
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const couponDetailData = couponDetail?.data ?? null;

  return (
    <div className="wrapper p-4">
      <Breadcrumbs />
      {couponDetailData ? (
        <EditPromotionCouponForm defaultCouponData={couponDetailData} />
      ) : (
        <></>
      )}
    </div>
  );
};
